import * as React from "react"

const SvgSendScheduled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 19.214v-13q0-.55.438-.837a.96.96 0 0 1 .937-.088l9.975 4.175q.475.201.575.588t-.05.737-.5.55q-.35.201-.825 0L5 7.714v3.5l3.1.775q.274.075.412.275a.78.78 0 0 1 .138.45.78.78 0 0 1-.138.45.7.7 0 0 1-.412.275l-3.1.775v3.5l3.725-1.575q.475-.2.813-.012a1.115 1.115 0 0 1 .537 1.275q-.1.387-.575.587l-5.1 2.15a.99.99 0 0 1-.95-.087Q3 19.764 3 19.214m14 3.5q-2.075 0-3.537-1.462Q12 19.79 12 17.714t1.463-3.537q1.462-1.463 3.537-1.463c2.075 0 2.563.488 3.538 1.463Q22 15.639 22 17.714t-1.462 3.538Q19.074 22.714 17 22.714m.5-5.2v-2.3a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0 .48.48 0 0 0-.15.35v2.275q0 .2.075.388.075.187.225.337l1.5 1.5a.48.48 0 0 0 .7 0 .48.48 0 0 0 0-.7z" />
  </svg>
)
export default SvgSendScheduled
